export const viewTitle = "Список исторических справок";
export const viewUniqKey = "historicalNotes";
